import { DrugDrugInteraction, RequestBatchResult } from "domain/entities/drug-drug-interaction";
import { DrugDrugInteractionRepository } from "domain/repositories";

export default class CreateBatchUseCase {
    private drugDrugInteractionRepository: DrugDrugInteractionRepository;
    
    public constructor(drugDrugInteractionRepository: DrugDrugInteractionRepository) {
        this.drugDrugInteractionRepository = drugDrugInteractionRepository
    }

    public async createDrugDrugInteractionBatch(drugDrugInteraction: DrugDrugInteraction[], token: Promise<[string | null, string | null]>): Promise<[RequestBatchResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugDrugInteractionRepository.createDrugDrugInteractionBatch(drugDrugInteraction, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}